import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const categoryFieldsFragment = gql`
  fragment AdminCategoryFields on Category {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    name
    archived
    parent {
      _id
      name
    }
    rLeaf
  }

  ${sanityDocumentFieldsFragment}
`;
